export default {
  panel: {
    class: 'overflow-hidden rounded-md mt-[2px]',
  },
  header: {
    class: ['rounded-md', 'outline-none'],
  },
  headercontent: ({ context }) => ({
    class: [
      // Shape
      'rounded-md',
      // Color
      'bg-surface-0 dark:bg-surface-900',
      'text-surface-600 dark:text-surface-0/80',
      { 'text-surface-900': context.active },
      // States
      'hover:bg-surface-100 dark:hover:bg-[rgba(255,255,255,0.03)]',
      'hover:text-surface-900',
      // Transition
      'transition duration-200 ease-in-out',
      'transition-shadow duration-200',
    ],
  }),
  headeraction: {
    class: [
      'relative',
      'font-semibold',
      'leading-none',
      'flex items-center',
      'py-2 px-3',
      'select-none cursor-pointer no-underline',
    ],
  },
  headerlabel: {
    class: 'leading-none',
  },
  headerIcon: {
    class: 'mr-2',
  },
  submenuicon: {
    class: 'mr-2',
  },
  menucontent: {
    class: ['pl-4', 'text-surface-700 dark:text-white/80', 'bg-surface-0 dark:bg-surface-900'],
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none',
    ],
  },
  menuitem: {
    class: 'relative mt-[2px]',
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-md',

      // Colors
      'text-surface-700 dark:text-white/80',
      {
        'text-surface-500 dark:text-white/70': !context.focused && !context.active,
        // 'text-surface-500 dark:text-white/70 bg-surface-200': context.focused && !context.active,
        'text-primary-highlight-inverse bg-primary-highlight':
          (context.focused && context.active) ||
          context.active ||
          (!context.focused && context.active),
      },

      // Transitions
      'transition-shadow',
      'duration-200',

      // States
      {
        'hover:bg-surface-100 dark:hover:bg-[rgba(255,255,255,0.03)]': !context.active,
        'hover:bg-primary-highlight-hover text-primary-highlight-inverse': context.active,
      },

      // Disabled
      { 'opacity-60 pointer-events-none cursor-default': context.disabled },
    ],
  }),
  action: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-2',
      'px-3',

      // Color
      'text-surface-700 dark:text-white/80',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none',
    ],
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-surface-600 dark:text-white/70',
    ],
  },
  submenu: {
    class: 'p-0 pl-4 m-0 list-none',
  },
  transition: {
    enterFromClass: 'max-h-0',
    enterActiveClass:
      'overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]',
    enterToClass: 'max-h-[1000px]',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      'overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]',
    leaveToClass: 'max-h-0',
  },
}
